/*
 HotelWarunki

 Tresc warunkow korzystania z uslugi webHotelBook
  
 historia: 
  PM 2021-11-27 - start
*/

import * as React from 'react';

import { Button, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';

class HotelWarunki extends React.Component<WithStyles<typeof styles>> {

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Typography variant='body2'>
                    Strona vscHotelBook to serwis umożliwiający dokonywanie rezerwacji hotelowych oraz oferujący informacje na temat różnych rodzajów zakwaterowania w obrębie wybranego hotelu.
                </Typography>
                <br />
                <Typography variant='body2'><b>Zakres stosowania</b></Typography>
                <Typography variant='body2'>
                    1.1. Ogólne warunki użytkowania, które okazjonalnie podlegają zmianom, dotyczą wszystkich naszych usług, które oferujemy bezpośrednio lub pośrednio (przez osoby trzecie) w internecie, na urządzeniach mobilnych, przez e-mail lub telefonicznie.
                </Typography>
                <Typography variant='body2'>
                    {'1.2. Korzystając z naszej strony internetowej, użytkownik oświadcza, że przeczytał, zrozumiał i akceptuje warunki użytkowania i '}
                    <a href="https://vsc24.net/vscZasady/zasady/vscHotelBook/Polityka" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.button}`}
                        >
                            politykę prywatności,
                        </Button>
                    </a>
                    {' łącznie z '}
                    <a href="https://vsc24.net/vscZasady/zasady/Cookies/Standard" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.button}`}
                        >
                            informacjami o stosowaniu plików cookies.
                        </Button>
                    </a>
                </Typography>
                <br />
                <Typography variant='body2'><b>Usługi</b></Typography>
                <Typography variant='body2'>
                    Strona internetowa vscHotelBook umożliwia dokonywanie rezerwacji hotelowych w systemie należącym do VIRTUAL s.c. z siedzibą w Rzeszowie. vscHotelBook nie świadczy usług hotelowych, ale jest pośrednikiem umożliwiającym skorzystanie z usług danego hotelu korzystającego z serwisu, będącego klientem firmy VIRTUAL s.c.
                </Typography>
                <br />
                <Typography variant='body2'><b>Ochrona danych</b></Typography>
                <Typography variant='body2'>
                    vscHotelBook będzie zbierać, przetwarzać i wykorzystywać jedynie te dane, które są niezbędne, by świadczyć usługi oferowane przez vscHotelBook, na potrzeby użytkowania i działania stron internetowych/aplikacji i oferowanych usług. Dane klientów są przekazywane jedynie podmiotom, które wykonują daną usługę hotelową tj. hotelom będącym klientami VIRTUAL s.c. korzystającym ze strony vscHotelBook. Przekazane dane są przechowywane i przetwarzane zgodnie z politykami prywatności i regulaminem hotelu wykonującego wybraną usługę.
                </Typography>
                <br />
                <Typography variant='body2'><b>Zobowiązania użytkowników</b></Typography>
                <Typography variant='body2'>
                    Treści dostępne na stronie internetowej vscHotelBook są chronione prawem autorskim. Całkowite lub częściowe powielanie treści, w szczególności dla reklamy lub innych form komercyjnego użytkowania, wymaga uprzedniej pisemnej zgody VIRTUAL s.c. z siedzibą w Rzeszowie. Sporządzanie kopii treści dla osobistego, niekomercyjnego użytku jest dozwolone, pod warunkiem, że pochodzenie treści jest wyraźnie widoczne (warunek powołania się na źródło pierwotne). Każde inne kopiowanie lub rozpowszechnianie treści bez uprzedniej pisemnej zgody VIRTUAL s.c. jest zabronione. Wniosek o prawo użytkowania można złożyć pod adresem vsc.and.fcm@gmail.com.
                </Typography>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
    }
});

export default withStyles(styles)(HotelWarunki);
